const screens = {
  xxs: "475px",
  xs: "560px",
  mdlrg: "910px",
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px",
  "2xl": "1536px",
};

module.exports = {
  screens,
};
